export default function () {

  $(window).load(function() {

    var colWidth = $('.insta-feed__column').width();
    var colWrap = $('.insta-feed__overlay-wrap');

    $(colWrap).height(colWidth);
  });

}



// WEBPACK FOOTER //
// ./scripts/components/SetupInstaColumns.js